export interface AzureAdConfiguration {
  tenantName: string;
  clientId: string;
  scopes: string[];
  policyNames: {
    [key: string]: string;
  };
}

export interface AppConfig {
  API_BASE_URL: string;
  SESSION_TIMEOUT?: string | number;
  FEATURES: {
    LOG_LEVEL: string;
    IS_STATISTICS: string;
    IS_DARK_THEME: string;
    IS_MOCK_ENABLED: string;
    IS_DEBUG_ENABLED: string;
    IS_AUTH_DISABLED: string;
    IS_USER_STEP_ENABLED: string;
  };
}

export const config: AzureAdConfiguration = window.AzureAdConfiguration ?? {};

export const appConfig: AppConfig = window.APP_CONFIG ?? {};
